import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getBscGlobalState } from '../../../common/utils';
import { LEGACY_ATLASSIAN_GDPR_COOKIE_KEY } from '../../../constants';
import { PreferenceCategory } from '../../../types';
import { setConsentToken } from '../../cookie-controls/set-consent-token';
import { setStrictlyNecessaryCookie } from '../../cookie-controls/set-strictly-necessary-cookie';
import { packUserPreferences } from '../../cookie-controls/transformer';
var emptyDisplayedTextMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PreferenceCategory.Analytics, ''), PreferenceCategory.Functional, ''), PreferenceCategory.Marketing, ''), PreferenceCategory.StrictlyNecessary, ''), PreferenceCategory.Unknown, '');
export function updatePreferences(_x) {
  return _updatePreferences.apply(this, arguments);
}
function _updatePreferences() {
  _updatePreferences = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(preferences) {
    var displayedTextMap,
      usingPrefetchedData,
      packedPrefs,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          displayedTextMap = _args.length > 1 && _args[1] !== undefined ? _args[1] : emptyDisplayedTextMap;
          usingPrefetchedData = _args.length > 2 ? _args[2] : undefined;
          if (!getBscGlobalState().localConsentMode) {
            _context.next = 7;
            break;
          }
          packedPrefs = packUserPreferences(preferences);
          setStrictlyNecessaryCookie(LEGACY_ATLASSIAN_GDPR_COOKIE_KEY, packedPrefs, {
            expires: 365,
            path: '/'
          });
          _context.next = 9;
          break;
        case 7:
          _context.next = 9;
          return setConsentToken(preferences, displayedTextMap, usingPrefetchedData);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _updatePreferences.apply(this, arguments);
}